
<template>
  <div id="layout-wrapper">
    <AppNavbar />
    <div>
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box text-center">
          <!-- Dark Logo-->
          <a :href="absoluteUrl()" class="logo logo-dark">
            <span class="logo-sm">
              <img :src="absoluteUrl('/images/logos/logo-sm-dark.png')" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img :src="absoluteUrl('/images/logos/logo-dark.webp')" alt="" height="27" />
            </span>
          </a>
          <!-- Light Logo-->
          <a :href="absoluteUrl()" class="logo logo-light">
            <span class="logo-sm">
              <img :src="absoluteUrl('/images/logos/logo-sm-light.png')" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img :src="absoluteUrl('/images/logos/logo-light.webp')" alt="" height="27" />
            </span>
          </a>
          <button
            type="button"
            class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i class="ri-record-circle-line"></i>
          </button>
        </div>

        <SimpleBar id="scrollbar" class="h-100" ref="scrollbar">
          <AppMenu></AppMenu>
        </SimpleBar>
        <div class="sidebar-background">
          <div class="circles-container" ><div class="circle-back" ></div><div class="circle-front" ></div></div>
        </div>
      </div>
      <!-- Left Sidebar End -->
      <!-- Vertical Overlay-->
      <div @click="toggleMenu()" class="vertical-overlay"></div>
    </div>
    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->
        <div class="container-fluid pb-5">
          <!-- <PageHeader :title="pageTitle" :items="breadCrumb" /> -->
          <!-- <RouterView /> -->
          <router-view v-slot="{ Component }">
            <transition name="fade-bottom-2x" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
      <AppFooter />
    </div>
    <vue-easy-lightbox :visible="lightbox.visible" :imgs="lightbox.files"
    :index="lightbox.index" @hide="initializeAll()"></vue-easy-lightbox>

    <b-modal
        size="lg"
        v-model="pdfModalFrame.visible"
        @hide="initializeAll()"
        title="View PDF"
        hide-footer>
        <iframe
        v-if="pdfModalFrame.filePath"
        :src="pdfModalFrame.filePath"
        style="width: 100%; height: 600px;"
        frameborder="0"
        ></iframe>
    </b-modal>

    <b-modal v-model="enableVerification" size="lg" hide-footer centered
        title="Complete your verification" :no-close-on-backdrop="true"
        :no-close-on-esc="true" hide-header-close title-class="">
        <div class="">
            <verification-form v-if="verification"
            :verification="verification" @completed="$store.dispatch('fetchDashboardData')"  />
        </div>
    </b-modal>
  </div>
</template>

<script>
import router from "@/router";
import { SimpleBar } from "simplebar-vue3";
import { layoutComputed } from "@/store/helpers";

import AppNavbar from "@/components/AppNavbar";
import AppMenu from "@/components/AppMenu.vue";
import AppFooter from "@/components/AppFooter";
import PageHeader from "@/components/PageHeader";
import VueEasyLightbox from "vue-easy-lightbox";
import VerificationForm from '@/components/forms/VerificationForm.vue'

/**
 * Vertical layout
 */
export default {
  components: { 
    AppNavbar, AppFooter, SimpleBar,
    AppMenu, PageHeader, VueEasyLightbox,
    VerificationForm
 },
  data() {
    return {
      isMenuCondensed: false,
      pageTitle: "Dashboard",
      breadCrumb: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Dashboard",
          active: true,
        },
      ],
    };
  },
  computed: {
    ...layoutComputed,
    lightbox(){
      return this.$store.state.lightbox
    },
    pdfModalFrame(){
      return this.$store.state.pdfModalFrame
    },
    verification(){
        return this.$store.state.dashboardData.verification
    },
    enableVerification: {
        get() {
            return !!this.verification;
        },
        set(value) {
        }
    }
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed"); 
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("vertical-sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("vertical-sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("vertical-sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    setEnvironment(){
      document.documentElement.setAttribute("data-layout-mode", this.mode);
      document.documentElement.setAttribute("data-sidebar", this.sidebarColor);
      document.documentElement.setAttribute("data-layout-style","default");  
      document.documentElement.setAttribute("data-layout-position", this.position);
      document.documentElement.setAttribute("data-sidebar-size", this.sidebarSize);
      document.documentElement.setAttribute("data-topbar", this.topbar);
      document.documentElement.setAttribute("data-layout-width", this.layoutWidth);
      document.documentElement.setAttribute("data-layout", this.layoutType);
    },
    initializeAll(){
      this.$store.commit('TOGGLE_LIGHT_BOX')
      this.$store.commit('TOGGLE_PDF_MODAL_FRAME')
    }
  },
  mounted() {
    this.$store.dispatch('fetchConfigData')
    if(this.$route.path !== '/') { 
        this.$store.dispatch('fetchDashboardData')
    }
    this.setEnvironment();
  },
};
</script>

<style>

.app-menu .navbar-brand-box{
  background: var(--bs-body-bg);
  margin-right: -1px;
}

#pdfFrameModal {
  z-index: 1060;
}
</style>